<template>
  <v-container fluid>
    <v-row justify="center">
      <v-btn color="primary" dark x-large style="padding: 15px 75px;" class="justify-center" @click="selected">
        {{ $t('GO') }}
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import {User} from "../models/user";

export default {
    name: "InvoiceItem",
    props: {
        invoice: {
            type: Object,
            default: null
        }
    },
    data () {
        return {
            clientName: '',
            userMod: null,
            bypay: true
        };
    },
    created () {
        this.fetch();
    },
    methods: {
        fetch () {
            if (this.invoice) {
                let client = null;
                if (this.invoice.receiver && this.invoice.receiver._id.toString() === this.$user._id.toString()) {
                    client = this.invoice.payer;
                    this.bypay = false;
                } else if (this.invoice.receiver) {
                    client = this.invoice.receiver;
                }
                if (client) {
                    this.userMod = new User(client);
                    this.clientName = this.userMod.getName();
                }
            }
        },
        selected () {
            this.$emit('invoiveMissingInformation', {invoice: this.invoice, bypay: this.bypay});
        }
    }
};
</script>

<style scoped>

</style>
